import type { ElementType } from "react";

import { ShareSessionToggleSwitch } from "./ShareSessionToggleSwitch";

import { cn } from "@/lib/utils";

export const ShareSessionCardToggle = ({
  icon: Icon,
  label,
  checked,
  onChange,
}: {
  icon: ElementType;
  label: string;
  checked: boolean;
  onChange: (v: boolean) => void;
}) => (
  <div className="flex items-center justify-between py-1.5">
    <div className="flex items-center gap-2">
      <Icon
        className={cn(
          "h-3.5 w-3.5 transition-colors duration-150",
          checked ? "text-blue-500" : "text-gray-300 dark:text-gray-600",
        )}
      />
      <span className="text-xs text-gray-600 dark:text-gray-400">{label}</span>
    </div>
    <ShareSessionToggleSwitch checked={checked} onChange={onChange} />
  </div>
);
